import { render, staticRenderFns } from "./DeletedOrdersDialog.vue?vue&type=template&id=2afdd807"
import script from "./DeletedOrdersDialog.vue?vue&type=script&lang=js"
export * from "./DeletedOrdersDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports